<!--
 * @Date: 2023-01-31 15:59:27
 * @LastEditTime: 2026-05-20 10:58:36
 * @Description: 
 * @FilePath: \lsz-user-mp\src\views\user\checkup\list.vue
-->
<template>
  <div>
    <patientAllSelect @onConfirm="patientConfirm" />
    <div class="empty-text">
      <span style="color: #666;">可查询范围：所有门诊检查报告以及2026年4月20号及以后出院满3天的住院检查报告。</span>
      <span>温馨提示：所有报告请于报告完成的第二日再进行查询</span>
    </div>
    <load-more :data-source="dataList" :total="total" :loading="loading" @load-more="onLoad">
      <CheckupItem :pat-id="String(patientId)" :data="dataList" />
    </load-more>
  </div>
</template>

<script>
//  import { userModel } from '@/api/user'
import loadMore from '@/assets/js/mixin/load-more'
import CheckupItem from '@/components/checkupItem/checkupItem.vue'
import {patientModel} from "../../../api/patient"

export default {
  name:'List',
  components:{
    CheckupItem
  },
  mixins: [loadMore],
  data(){
    return{
      dataList:[],
      page:1,
      pageSize:10,
      patientId:'',
      patxm:'',
      zjh:'',
      total:0,
      loading: false
    }
  },
  mounted(){
    this.getList()
  },
  methods:{
    getList(){
      if (this.patientId == "") {
        return
      }
      let params={
        isPatAll: '0',
        page: this.page,
        pageSize: this.pageSize,
        patientId: this.patientId
        // patxm: this.patxm,
        // zjh: this.zjh
      }
      patientModel.checkupList(params).then(res=>{
        const newData = res.data || []
        if (this.page === 1) {
          // 首次加载或重置时，直接替换数据
          this.dataList = newData
        } else {
          // 加载更多时，追加数据
          this.dataList = [...this.dataList, ...newData]
        }
        this.total = res.count
      }).finally(() => {
        this.loading = false
      })
    },
    //选择就诊人
    patientConfirm(value){
      this.patientId = value.id
      // this.patxm=value.text
      // this.zjh=value.zjh
      this.page=1
      this.dataList=[]
      this.loading = true
      this.getList()
    },
    //分页加载更多
    onLoad(){
      this.page += 1
      this.loading = true
      this.getList()
    }
  }
}
</script>
<style scoped>
.empty-text {
  padding: 10px;
  /* text-align: center; */
  font-size: 22px;
  color: #DC3030 !important;
}
</style>